import { render, staticRenderFns } from "./TasahelReports.vue?vue&type=template&id=612f81b2&"
import script from "./TasahelReports.vue?vue&type=script&lang=js&"
export * from "./TasahelReports.vue?vue&type=script&lang=js&"
import style0 from "./TasahelReports.vue?vue&type=style&index=0&id=612f81b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports